import { Component, Injector, Input, OnInit } from '@angular/core';
import { ApAlertService , ApBaseModalComponent } from 'webcommon/core-ui';
import { FindControlIdService } from 'webcommon/legacy-common';

// todo: this component is not standalone or declared in any module
@Component({
  selector: 'ap-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.less'],
  providers: [ApAlertService]
})
export class DeleteModalComponent extends ApBaseModalComponent<boolean | null> implements OnInit {
  @Input() title: string;
  @Input() controlId: string;
  public contextLabels = new Map<string, string>([
    [this.findControlIdService.ListRPNOptions, 'RPN Viewing Options'],
    [this.findControlIdService.ViewFNDUserFilters, 'Find Filter'],
  ]);
  constructor(
    public findControlIdService: FindControlIdService,
    elementInjector: Injector
  ) {
    super(elementInjector);
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  cancel(): void {
    this.closeModal(null);
  }

  onOk(): void {
    this.closeModal(true);
  }


  getContextLabel(): string {
    return this.contextLabels.get(this.controlId) || '';
  }
}
